import React, { useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';

import { isArray, isEmpty, isNull } from 'lodash';
import moment from 'moment';

import { Report } from '~/components';
import {
  Autocomplete,
  DateTime,
  Hidden,
  Input,
  MultiAutocomplete,
  RadioGroup,
  Select,
} from '~/components/Form';
import { CRUDProfile, PesquisaTabela } from '~/components/Form/v2';
import { REL_ALARME_SISTEMA } from '~/constants/default';
import { t } from '~/helpers';
import api from '~/services/api';

function Relalarmesistema() {
  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [posto, setPosto] = useState(0);

  const [valuePosto, setValuePosto] = React.useState(0);
  const [inputValuePosto, setInputValuePosto] = React.useState('');
  const [alarmesConfig, setAlarmesConfig] = useState([]);
  const [codigoLabelSistema, setCodigoLabelSistema] = useState('');

  const [statusStr, setStatusStr] = React.useState('');

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });

  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const cellsUser = useMemo(
    () => [
      {
        id: 'codigousuario',
        label: t('s.cadastro.usuario.codigousuario'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeusuario',
        label: t('s.cadastro.usuario.nomeusuario'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const statusalarmesistemaoptions = [
    { value: '0', label: t('s.relatorio.geral.todos') },
    { value: '1', label: t('s.geral.alarmesistema.ativonaoreconhecido') },
    { value: '2', label: t('s.geral.alarmesistema.ativoreconhecido') },
    { value: '3', label: t('s.geral.alarmesistema.inativonaoreconhecido') },
    { value: '4', label: t('s.geral.alarmesistema.inativoreconhecido') },
  ];

  const orderoptions = [
    { value: 'LI', label: t('s.relatorio.abastecimento.opcaolistagem') },
    { value: 'AL', label: t('c.menu.alarme.titulo') },
    { value: 'DT', label: t('s.relatorio.abastecimento.opcaodata') },
    { value: 'PC', label: t('s.relatorio.abastecimento.opcaopostocomboio') },
    { value: 'ST', label: t('s.geral.camposistema.statusalarmesistema') },
    { value: 'FT', label: t('s.relatorio.abastecimentolistagem.frentista') },
  ];

  useEffect(() => {
    async function buscaAlarmesConfig() {
      try {
        setLoading(true);

        const { data } = await api.get('alarmesconfigclientes', {
          params: { pesquisalista: true, pagesize: 9999 },
        });

        if (!isEmpty(data)) {
          const opts = [];

          opts.push({ value: '0', label: t('s.relatorio.geral.todos') });
          data.items.map((value) => {
            opts.push({
              value: value.idalarmeconfig,
              label: t(value.codigolabelsistema),
            });
          });
          setAlarmesConfig(opts);
        } else {
          setAlarmesConfig([]);
        }
      } catch (err) {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      } finally {
        setLoading(false);
      }
    }

    buscaAlarmesConfig();
  }, []);

  function configuraCodigoLabelSistema(idalarmeconfig) {
    let label = '';

    alarmesConfig.map((alarme) => {
      if (!isNull(idalarmeconfig) && alarme.value === idalarmeconfig) {
        label = alarme.label;
      }
    });

    setCodigoLabelSistema(label);
  }

  function configuraStatusStr(idstatus) {
    let label = '';

    statusalarmesistemaoptions.map((status) => {
      if (!isNull(idstatus) && status.value === idstatus) {
        label = status.label;
      }
    });

    setStatusStr(label);
  }

  function handleSerializeForm(params) {
    const idPosto =
      valuePosto === 0 ? '' : valuePosto?.map((posto) => posto.idposto);
    //  const idBico = valueBico === 0 ? '' : valueBico;

    return {
      ...params,
      idposto: idPosto,
      //     idbico: idBico,
      idalarmeconfigstr: codigoLabelSistema,
      statusstr: statusStr,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.relatorio.alarmesistema')}
      relatorio="alarmesistema"
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
        idalarmeconfig: 0,
        statusalarmesistema: '0',
        origemalarmesistema: '',
        mensagemalarmesistema: '',
        tipoordenacaoreport: 'LI',
        idperfilrelatorio: '0',
        idgrupocamposistema: REL_ALARME_SISTEMA,
      }}
    >
      <DateTime
        label={t('s.geral.opcoes.datahorainicial')}
        name="datahorainicial"
        serialize={(value) =>
          value.set({ second: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <DateTime
        label={t('s.geral.opcoes.datahorafinal')}
        name="datahorafinal"
        serialize={(value) =>
          value.set({ second: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <Select
        name="idalarmeconfig"
        label={t('s.configuracao.alarmesistema')}
        options={alarmesConfig.map((op) => ({
          label: op.label,
          value: op.value,
        }))}
        disabled={loading}
        getValue={(value) => {
          configuraCodigoLabelSistema(value);
        }}
      />

      <Select
        name="statusalarmesistema"
        variant="outlined"
        size="small"
        label={t('s.configuracao.posto.statusposto')}
        options={statusalarmesistemaoptions}
        getValue={(value) => {
          configuraStatusStr(value);
        }}
      />

      <MultiAutocomplete
        multiple
        name="idposto"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.geral.postocomboio')}
        hiddens={[{ name: 'codigonomeposto' }]}
        getValue={(value) => {
          if (value[0]?.idposto === null) {
            setValuePosto(0);
            setInputValuePosto('');
          } else {
            setValuePosto(value);
          }
        }}
      />

      <Input
        type="text"
        name="origemalarmesistema"
        label={t('s.geral.alertasistema.origemalarmesistema')}
      />

      <Input
        type="text"
        name="mensagemalarmesistema"
        label={t('s.geral.camposistema.mensagemalarmesistema')}
      />

      <PesquisaTabela
        name="frentista"
        label={t('s.relatorio.abastecimentocontingencia.frentista')}
        primary="codigousuario"
        secondary="nomeusuario"
        url="usuarios"
        header={cellsUser}
      />

      <Select
        name="tipoordenacaoreport"
        variant="outlined"
        size="small"
        label={t('s.relatorio.abastecimento.tipoordenacao')}
        options={orderoptions}
      />

      <CRUDProfile
        name="idperfilrelatorio"
        label={t('s.menu.cadastro.usuario.perfil')}
        report={REL_ALARME_SISTEMA}
        nameReport={t('s.configuracao.alarmesistema')}
      />

      <Hidden name="idgrupocamposistema" />

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relalarmesistema;
